import * as React from 'react';
import { reportDisplay } from './reportNumbers';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

const colorStyles = {
  blue: {
    bg: 'bg-blue-50 dark:bg-blue-900/20',
    border: 'border-blue-200 dark:border-blue-800',
    title: 'text-blue-700 dark:text-blue-300',
    value: 'text-blue-900 dark:text-blue-200',
  },
  purple: {
    bg: 'bg-purple-50 dark:bg-purple-900/20',
    border: 'border-purple-200 dark:border-purple-800',
    title: 'text-purple-700 dark:text-purple-300',
    value: 'text-purple-900 dark:text-purple-200',
  },
  green: {
    bg: 'bg-green-50 dark:bg-green-900/20',
    border: 'border-green-200 dark:border-green-800',
    title: 'text-green-700 dark:text-green-300',
    value: 'text-green-900 dark:text-green-200',
  },
  yellow: {
    bg: 'bg-yellow-50 dark:bg-yellow-900/20',
    border: 'border-yellow-200 dark:border-yellow-800',
    title: 'text-yellow-700 dark:text-yellow-300',
    value: 'text-yellow-900 dark:text-yellow-200',
  },
  indigo: {
    bg: 'bg-indigo-50 dark:bg-indigo-900/20',
    border: 'border-indigo-200 dark:border-indigo-800',
    title: 'text-indigo-700 dark:text-indigo-300',
    value: 'text-indigo-900 dark:text-indigo-200',
  },
  cyan: {
    bg: 'bg-cyan-50 dark:bg-cyan-900/20',
    border: 'border-cyan-200 dark:border-cyan-800',
    title: 'text-cyan-700 dark:text-cyan-300',
    value: 'text-cyan-900 dark:text-cyan-200',
  },
  rose: {
    bg: 'bg-rose-50 dark:bg-rose-900/20',
    border: 'border-rose-200 dark:border-rose-800',
    title: 'text-rose-700 dark:text-rose-300',
    value: 'text-rose-900 dark:text-rose-200',
  },
  emerald: {
    bg: 'bg-emerald-50 dark:bg-emerald-900/20',
    border: 'border-emerald-200 dark:border-emerald-800',
    title: 'text-emerald-700 dark:text-emerald-300',
    value: 'text-emerald-900 dark:text-emerald-200',
  },
};

export default function KPI({
  title,
  value,
  color = 'blue',
  id,
}) {
  const styles = colorStyles[color] || colorStyles.blue;

  return (
    <Box sx={{ minWidth: 0 }}>
<Card
  id={id}
  variant="outlined"
  data-accent={color}
  className={`reports-kpi ${styles.bg} ${styles.border} rounded-lg shadow-sm h-[130px]`}
>
  <CardContent className="p-4 h-full flex flex-col">
    <Typography
      component="h4"
      variant="body2"
      className={`${styles.title} text-sm font-medium`}
    >
      {title}
    </Typography>

    <Typography
      component="p"
      variant="h4"
      className={`${styles.value} text-2xl font-bold mt-1`}
    >
          {reportDisplay(value)}
    </Typography>
  </CardContent>
</Card>
    </Box>
  );
}
